import noticeAccount from "@/components/modal/noticeAccount/layout.vue";
export default {
  metaInfo: {
    title: "비밀번호 변경",
  },
  components: { noticeAccount },
  data() {
    return {
      user: {
        password: "",
        confirmPassword: "",
      },
      isUnmatchedPassword: false,
      openModal: false,
      popup: "",
      isInvalidatePassword: false,
    };
  },
  mounted() {},
  computed: {},
  created() {
    this.accessPasswordUpdate();
  },
  destroyed() {
    this.$store.dispatch("account/initializationUserInfo");
  },
  methods: {
    updatePassword() {
      const payload = {
        password: this.user.password,
      };

      try {
        this.$store.dispatch("account/updateUserPw", payload).then((data) => {
          if (data.success) {
            this.openNoticeModal(
              "비밀번호 변경이 완료되었어요!\n로그인 화면으로 이동할게요."
            );
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    //비밀번호 일치확인
    checkPassword() {
      this.isUnmatchedPassword =
        this.user.password !== this.user.confirmPassword;
      return this.isUnmatchedPassword;
    },
    openNoticeModal(popup) {
      this.openModal = true;
      this.popup = popup || "내부 서버 오류";
    },
    validatePassword(password) {
      const moreThan10 = password.length > 9; // 10자리이상
      const engCondition = /[A-Za-z]/.test(password); // 영문포함
      const numCondition = /[0-9]/.test(password); // 숫자포함

      if (!moreThan10 || !engCondition || !numCondition) return false;

      return true;
    },
    accessPasswordUpdate() {
      if (!this.$store.state.account.userInfo.authToken)
        this.$router.replace("/users/find-account");
    },
    moveToBack() {
      this.$router.replace("/users/find-account");
    },
  },
};
